/**
 * Buck-e API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ManuallyAddRfidEventToParticipantStatus {
    RFID_EVENT_ALREADY_EXISTS_FOR_THIS_DAY = 'RFID_EVENT_ALREADY_EXISTS_FOR_THIS_DAY',
    NO_RFID_TAG_FOR_THIS_DISPLACEMENT_TYPE = 'NO_RFID_TAG_FOR_THIS_DISPLACEMENT_TYPE',
    PARTICIPANT_WAS_NOT_REGISTERED_ON_THIS_DAY = 'PARTICIPANT_WAS_NOT_REGISTERED_ON_THIS_DAY',
    PARTICIPANT_HAS_NO_RFID_TAGS = 'PARTICIPANT_HAS_NO_RFID_TAGS',
    ADDED_SUCCESSFULLY = 'ADDED_SUCCESSFULLY'
}

